import React from "react";
import { useEffect, useState } from "react";

const BackToTopButton = () => {
  const [backToTopButton, setBackToTopButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setBackToTopButton(true);
      } else {
        setBackToTopButton(false);
      }
    });
  }, []);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="btn-up-container">
      {backToTopButton && (
        <div className="btn-up" onClick={scrollUp}>
          <span>🔼</span>
          <span>Haut De Page</span>
        </div>
      )}
    </div>
  );
};
export default BackToTopButton;
